import React from 'react'
import './style.scss'

const ModalHeader = ({trip_id}) => {
    return (
        <div style={{ display: 'flex',height:'auto' ,flexDirection:'row' ,backgroundColor:'#0A2638', justifyContent:'start',alignItems:'center'}}>
            <span className='modalHeader' style={{marginRight:30,marginLeft:10}}>TRIP ID: {trip_id}</span>
        </div>     
    )
}

export default ModalHeader

